/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentStateRollback,
  AgentStateRollback$Outbound,
  AgentStateRollback$outboundSchema,
} from "./agentstaterollback.js";

/**
 * The device agent's update posture.
 */
export type AgentStateUpdate = {
  /**
   * Auto-update mode: disabled, notify, or automatic.
   */
  autoUpdate?: string | undefined;
  /**
   * Release channel the agent resolved to.
   */
  channel?: string | undefined;
  /**
   * True when the running build is in blocked_versions.
   */
  currentBlocked?: boolean | undefined;
  /**
   * A self-rollback: the daemon reverted an update that did not stabilize.
   */
  lastRollback?: AgentStateRollback | undefined;
  /**
   * Version the organization pinned the fleet to, when set.
   */
  pinnedTarget?: string | undefined;
};

/** @internal */
export type AgentStateUpdate$Outbound = {
  auto_update?: string | undefined;
  channel?: string | undefined;
  current_blocked?: boolean | undefined;
  last_rollback?: AgentStateRollback$Outbound | undefined;
  pinned_target?: string | undefined;
};

/** @internal */
export const AgentStateUpdate$outboundSchema: z.ZodMiniType<
  AgentStateUpdate$Outbound,
  AgentStateUpdate
> = z.pipe(
  z.object({
    autoUpdate: z.optional(z.string()),
    channel: z.optional(z.string()),
    currentBlocked: z.optional(z.boolean()),
    lastRollback: z.optional(AgentStateRollback$outboundSchema),
    pinnedTarget: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      autoUpdate: "auto_update",
      currentBlocked: "current_blocked",
      lastRollback: "last_rollback",
      pinnedTarget: "pinned_target",
    });
  }),
);

export function agentStateUpdateToJSON(
  agentStateUpdate: AgentStateUpdate,
): string {
  return JSON.stringify(
    AgentStateUpdate$outboundSchema.parse(agentStateUpdate),
  );
}
